// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "PropertyBroadcastAllowed",
    "PropertyBroadcastNotAllowed"
  ]);
}

let fragmentConverter = {"__root":{"PropertyBroadcastAllowed_priceCondition_requiredUntil":{"b":""},"":{"u":"fragment"}}};

let fragmentConverterMap = {
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function broadcastNotAllowedReason_decode($$enum) {
  if ($$enum === "ARCHIVED" || $$enum === "REMOVED") {
    return $$enum;
  }
}

let broadcastNotAllowedReason_fromString = broadcastNotAllowedReason_decode;

let Utils = {
  broadcastNotAllowedReason_decode: broadcastNotAllowedReason_decode,
  broadcastNotAllowedReason_fromString: broadcastNotAllowedReason_fromString
};

let node = {
  "kind": "InlineDataFragment",
  "name": "PropertyWizardFormRelayBroadcastPolicy_policy"
};

let wrap_fragment = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
